import { Input, OnChanges, SimpleChange } from '@angular/core';

export class BaseTable {
  public tableTitle: string;
  public page = 1;
  public itemsPerPage = 20;
  public maxSize = 5;
  public numPages = 1;
  public length = 0;

  public data: Array<any> = null;
  public rows: Array<any> = [];
  public loading: boolean;
  public columns: Array<any> = [];

  public itemsPerPageOptions = [10, 20, 50, 100];
  public selectedItemsPerPage = this.itemsPerPage;

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };
  constructor() {
    const storedValue = localStorage.getItem('itemsPerPage');
    if (storedValue !== null) {
      this.itemsPerPage = Number(storedValue);
      this.selectedItemsPerPage = this.itemsPerPage;
    }
  }

  onChange(value: any): void {

    setTimeout(() => {
      const storedValue = Number(localStorage.getItem('itemsPerPage'));
      if (storedValue !== value) {
        localStorage.setItem('itemsPerPage', String(value));
        this.itemsPerPage = Number(value);
        this.onChangeTable(this.config);
      }
    });
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    const start = (page.page - 1) * page.itemsPerPage;
    const end =
      page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    const columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let columnType: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false && columns[i].sort !== undefined) {
        columnName = columns[i].name;
        columnType = columns[i].type;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {

      const previousValue = previous[columnName] == null ? 'N/A' : previous[columnName];
      const currentValue = current[columnName] == null ? 'N/A' : current[columnName];
      if (columnType === 'date') {
        console.log('sorting by date');
        previous = previousValue.split('-').reverse().join('');

        current = currentValue.split('-').reverse().join('');

        if (previous > current) {
          return sort === 'desc' ? -1 : 1;
        } else if (previous < current) {
          return sort === 'asc' ? -1 : 1;
        }
      }else {

          if (previousValue.toLowerCase() > currentValue.toLowerCase()) {
            return sort === 'desc' ? -1 : 1;
          } else if (previousValue.toLowerCase() < currentValue.toLowerCase()) {
            return sort === 'asc' ? -1 : 1;
          }
      }

      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name]
            .toLowerCase()
            .toString()
            .match(column.filtering.filterString.toLowerCase());
        });
      }
    });

     if (!config.filtering) {
      return filteredData;
     }

     if (config.filtering.columnName) {
       return filteredData.filter((item: any) =>
         item[config.filtering.columnName].match.toLowerCase.toString(
           this.config.filtering.filterString
         )
       );
     }

    const tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name] != null) {
          if (
            item[column.name]
              .toString()
              .match(this.config.filtering.filterString)
          ) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    const filteredData = this.changeFilter(this.data, this.config);
    const sortedData = this.changeSort(filteredData, this.config);
    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/shared/base-table.ts